<template>
  <v-col class="pa-0">
    <div v-if="!editingCompany" class="pa-6">
      <v-row>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-text-field
              class="input"
              label="Search..."
              prepend-inner-icon="mdi-magnify"
              rounded
              v-model="search"
              style="max-width: 300px"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              @change="setLastStatus"
              class="statusSelect input"
              style="max-width: 300px"
              label="Selected Status"
              rounded
              v-model="selectedStatus"
              :items="statusOptions"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row justify="center" justify-md="center">
            <VueJsonToCsv
              :json-data="exportData"
              :csv-title="'Client Companies'"
              class="export-btn mt-6"
            ></VueJsonToCsv>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="pa-6">
          <v-row
            v-if="storeUser && storeUser.adminType == 'Super Admin'"
            justify="center"
            justify-md="end"
            class="ma-0"
          >
            <v-btn
              @click="
                selectedCompany = null;
                editingCompany = true;
              "
              color="#e022d1"
              dark
              rounded
              width="auto"
              class="pink-btn"
            >
              Add Company
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-data-table
          no-data-text="No client companies yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredCompanies"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.companyName="{ item }">
            <td>
              <h4 class="blue-color">{{ item.companyName || "-" }}</h4>
              <p class="grey-color">{{ item.userType || "Company" }}</p>
            </td>
          </template>
          <template v-slot:item.contact="{ item }">
            <td>
              <p>{{ item.email || "-" }}</p>
              <p class="grey-color">{{ item.CellNo || item.contact || "-" }}</p>
            </td>
          </template>
          <template v-slot:item.address="{ item }">
            <td>{{ formatAddress(item.address) }}</td>
          </template>
          <template v-slot:item.languages="{ item }">
            <td>{{ formatList(item.languages) }}</td>
          </template>
          <template v-slot:item.vehicles="{ item }">
            <td>{{ formatCount(item.vehicles, "vehicle") }}</td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
            >
              {{ item.status || "pending" }}
            </v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedCompany = item;
                  editingCompany = true;
                "
              >
                mdi-pencil
              </v-icon>
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>

    <div v-if="editingCompany" class="pa-4">
      <HandleUser
        userType="Company"
        :user="selectedCompany"
        :companies="companies"
        :doctors="doctors"
        @userCreated="handleClose"
        @update="getCompanies"
      />
    </div>

    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="#4390c0"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
import HandleUser from "../components/HandleUser.vue";

import {
  collection,
  getFirestore,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        { text: "Company", value: "companyName" },
        { text: "Practice Number", value: "practiceNumber" },
        { text: "Contact", value: "contact" },
        { text: "Address", value: "address" },
        { text: "Languages", value: "languages" },
        { text: "Vehicles", value: "vehicles" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      companies: [],
      doctors: [],
      editingCompany: false,
      selectedCompany: null,
      search: "",
      selectedStatus: "all",
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Pending", value: "pending" },
        { text: "On Hold", value: "on hold" },
        { text: "Approved", value: "approved" },
        { text: "Denied", value: "denied" },
        { text: "Email Unverified", value: "Email Unverified" },
      ],
      loading: false,
      unsubscribeCompanies: null,
      unsubscribeDoctors: null,
    };
  },
  components: {
    HandleUser,
    VueJsonToCsv,
  },
  mounted() {
    if (localStorage.getItem("LastViewedCompanyStatusType")) {
      this.selectedStatus = localStorage.getItem(
        "LastViewedCompanyStatusType"
      );
    }

    this.getCompanies();
    this.getDoctors();

    if (localStorage.getItem("ViewedUser")) {
      const selectedUser = JSON.parse(localStorage.getItem("ViewedUser"));
      if (selectedUser.userType == "Company") {
        this.selectedCompany = selectedUser;
        this.editingCompany = true;
      }
    }
  },
  methods: {
    handleClose() {
      this.editingCompany = false;
      localStorage.removeItem("ViewedUser");
    },
    setLastStatus() {
      localStorage.setItem("LastViewedCompanyStatusType", this.selectedStatus);
    },
    getCompanies() {
      if (this.unsubscribeCompanies) {
        this.unsubscribeCompanies();
      }

      try {
        const q = query(collection(db, "clients"));
        this.loading = true;

        this.unsubscribeCompanies = onSnapshot(q, (querySnapshot) => {
          this.companies = [];

          querySnapshot.forEach((doc) => {
            const tempCompany = doc.data();
            tempCompany.id = doc.id;

            if (!tempCompany.status) {
              tempCompany.status = "pending";
            }

            this.companies.push(tempCompany);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    getDoctors() {
      if (this.unsubscribeDoctors) {
        this.unsubscribeDoctors();
      }

      try {
        const q = query(collection(db, "doctors"));

        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doc) => {
            const tempDoctor = doc.data();
            tempDoctor.id = doc.id;
            this.doctors.push(tempDoctor);
          });
        });
      } catch (error) {
        console.log("error: ", error);
      }
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    formatAddress(address) {
      if (!address) {
        return "-";
      }

      if (typeof address === "string") {
        return address;
      }

      return (
        address.placeName ||
        address.text ||
        address.addressText ||
        address.formattedAddress ||
        "-"
      );
    },
    formatList(items) {
      if (!items || !items.length) {
        return "-";
      }

      return items.join(", ");
    },
    formatCount(items, label) {
      if (!items || !items.length) {
        return "0 " + label + "s";
      }

      return items.length + " " + label + (items.length == 1 ? "" : "s");
    },
    isClientCompany(item) {
      return (
        item.userType == "Company" ||
        item.companyName ||
        item.practiceNumber ||
        item.companyId ||
        item.companyID
      );
    },
    normalizeCompanyName(companyName) {
      if (!companyName) {
        return "";
      }

      return companyName.toString().toLowerCase().replace(/[^a-z0-9]/g, "");
    },
    companyDataScore(company) {
      return [
        company.companyName,
        company.practiceNumber,
        company.email,
        company.CellNo || company.contact,
        this.formatAddress(company.address) != "-" ? company.address : null,
        company.languages && company.languages.length,
        company.vehicles && company.vehicles.length,
        company.status,
      ].filter(Boolean).length;
    },
  },
  computed: {
    uniqueCompanies() {
      const companiesByName = {};

      this.companies.forEach((company) => {
        if (!this.isClientCompany(company)) {
          return;
        }

        const key = this.normalizeCompanyName(company.companyName) || company.id;
        const existingCompany = companiesByName[key];

        if (
          !existingCompany ||
          this.companyDataScore(company) > this.companyDataScore(existingCompany)
        ) {
          companiesByName[key] = company;
        }
      });

      return Object.values(companiesByName);
    },
    filteredCompanies() {
      return this.uniqueCompanies.filter((item) => {
        const matchesStatus =
          this.selectedStatus === "Email Unverified"
            ? item.emailVerified !== true
            : this.selectedStatus == "all" ||
              !this.selectedStatus ||
              item.status === this.selectedStatus;

        const searchableValues = [
          item.companyName,
          item.practiceNumber,
          item.email,
          item.CellNo,
          item.contact,
          this.formatAddress(item.address),
          this.formatList(item.languages),
          item.status,
        ];

        const matchesSearch = searchableValues.some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        return matchesStatus && matchesSearch;
      });
    },
    exportData() {
      if (!this.filteredCompanies) {
        return [{}];
      }

      return this.filteredCompanies.map((company) => ({
        CompanyName: company.companyName,
        PracticeNumber: company.practiceNumber,
        Email: company.email,
        PhoneNumber: company.CellNo || company.contact,
        Address: this.formatAddress(company.address),
        Languages: this.formatList(company.languages),
        Vehicles: company.vehicles ? company.vehicles.length : 0,
        Status: company.status,
      }));
    },
    storeUser() {
      return this.$store.state.user || {};
    },
  },
  beforeDestroy() {
    if (this.unsubscribeCompanies) {
      this.unsubscribeCompanies();
    }

    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }
  },
};
</script>

<style scoped></style>





